export const environment = {
  production: true,
  envName: 'production',
  googleMapsApiKey: 'AIzaSyAzEyEDp-9994A5WgJncs29koF6UBJAJDQ',
  apiUrl: 'https://it-e76zlb3o4q-el.a.run.app/api/v1',
  chatWsUrl: 'wss://chat-190170265822.asia-south1.run.app',
  iosAppUrl: 'https://apps.apple.com/mx/app/townlee/id6792012167?l=en-GB',
  // Placeholder — swap for the real Play Store URL once Android is published.
  androidAppUrl: 'https://play.google.com/store/apps/details?id=com.example.townly'
};
